export default __webpack_public_path__ + "static/media/flower-icon.6aa6500c.svg";